import type { ServicePill, CreateAction, Suggestion } from './types';

export const API_URL = process.env.REACT_APP_API_URL || '';

// 9 service pills (Expenses first, HR last) in the approved order
export const SERVICES: ReadonlyArray<ServicePill> = [
  { id: 'expenses',   label: 'Expenses & Pay Bills', href: '/billpay' },
  { id: 'accounting', label: 'Accounting',           href: '/accounting' },
  { id: 'sales',      label: 'Sales & Get Paid',     href: '/invoices' },
  { id: 'customer',   label: 'Customer Hub',         href: '/customers' },
  { id: 'payroll',    label: 'Payroll',              href: '/payroll/overview' },
  { id: 'team',       label: 'Team',                 href: '/team' },
  { id: 'tax',        label: 'Sales Tax',            href: '/tax' },
  { id: 'marketing',  label: 'Marketing',            href: '/agents' },
  { id: 'hr',         label: 'HR',                   href: '/team' },
];

// Create actions (chips shown under the greeting)
export const CREATE_ACTIONS: ReadonlyArray<CreateAction> = [
  { id: 'invoice',       label: 'Create invoice',       href: '/invoices/new' },
  { id: 'sales-receipt', label: 'Create sales receipt', href: '/invoices/new?type=receipt' },
  { id: 'run-payroll',   label: 'Run payroll',          href: '/payroll/run' },
  { id: 'get-paid',      label: 'Get paid online',      href: '/invoices' },
  { id: 'record-expense',label: 'Record expense',       href: '/billpay' },
];

// Default suggestions (fallback if API returns none)
export const DEFAULT_SUGGESTIONS: ReadonlyArray<Suggestion> = [
  { id: 's-bank',   iconName: 'bank',   title: 'Connect your bank',             description: 'Auto-sync transactions, reconcile faster',       href: '/payroll/bank/connect' },
  { id: 's-chase',  iconName: 'send',   title: 'Send overdue invoice reminders', description: 'Vela drafted them, one click to send',          href: '/invoices?filter=overdue' },
  { id: 's-report', iconName: 'report', title: 'Run your Q4 financial report',   description: 'See profit and loss, cash position, tax forecast', href: '/reports' },
];

// How many Vela-prepared items to show in the queue
export const VELA_QUEUE_LIMIT = 8;

// Chart axis defaults
export const CASH_FLOW_MAX_Y = 1000; // placeholder; replace with real data range

// Vela approval types + data moved to src/vela-inbox/data.ts so the Dashboard
// no longer owns them. The Vela banner and the Vela inbox page read from there.